import React from 'react'
import './InnerLoader.css'
import lod from '../../../assets/images/pentalens-loader.png'
import { AbstructVar } from '../general-component/abstruct-component/AbstructVar'

function InnerLoader() {
    let {mode} = AbstructVar()
    return (
        <section className={`div_loading ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`}>
            <img src={lod} />
        </section>
    )
}

export default InnerLoader